<template>
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table v-if="dataTabla"  class="table table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Tienda</th>
          <th>Proveedor</th>
          <th class="text-center">Fecha</th>
          <th>Fecha Creacion</th>
          <th>Usuario</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="current in dataTabla.results" v-bind:key="current.id" @click="generar_orden_compra(current)">
          <td>{{ current.numero }}</td>
          <td>{{ current.tienda.nombre }}</td>
          <td>{{ current.proveedor.nombre }}</td>
          <td>{{ current.fecha }}</td>
          <td>
            <timeago :title="current.fecha_creacion" :datetime="current.fecha_creacion"></timeago>
          </td>
          <td>
            <UsuarioEnTablaComponent :current="current.usuario" />
          </td>

          <td class="text-center">
            <div data-title="Activo" data-toggle="tooltip" v-html="current.estado_str"></div>
          </td>
          <td class="text-center">
          </td>
        </tr>
      </tbody>

    </table>

    <!-------------------- END - Basic Table -------------------->

  </div>


</template>

<script>
import { mapGetters } from "vuex";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import CotizacionesService from "@/services/compras/CotizacionesService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    UsuarioEnTablaComponent
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: []
    };
  },
  computed: {
    ...mapGetters({
    })
  },
  mounted() {
  },
  props:["dataTabla"],
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("cotizaciones/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext
      });
    },
      irAEsconderModal(name, params) {
      if($('.modal').hasClass('show')){
        $('.modal').find('.close').click();
      }
      this.$router.push({
        name: name,
        params: params
      });
    },
    generar_orden_compra(current) {
      /**
       * Genera una COMPRA basada en LA COTIZACION
       */
      let self = this;
      CotizacionesService.generar_orden_compra(current.id)
        .then(response => {
          Notifications.alert.confirm(
            "Orden de Compra Generada",
            "Ir a la Orden de Compra Generada",
            "",
            function() {
              self.irAEsconderModal("compras-ordencompra-editar", { id: response.data.orden_compra_e });
            }
          );
        })
        .catch(error => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
  }
};
</script>
